import { svg } from "@opentiny/vue-common";
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", _vm._g({
    staticClass: "success_svg__tiny-icon-success",
    staticStyle: {
      "enable-background": "new 0 0 14 14"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 14 14",
      "xml:space": "preserve"
    }
  }, _vm.$listeners), [_c("path", {
    staticStyle: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd"
    },
    attrs: {
      "d": "M14 7c0 3.87-3.13 7-7 7s-7-3.13-7-7 3.13-7 7-7 7 3.13 7 7z"
    }
  }), _c("path", {
    staticStyle: {
      "fill": "#fff"
    },
    attrs: {
      "d": "M10.02 5.61 6.74 8.89c-.17.17-.4.27-.64.27s-.47-.1-.64-.27L3.98 7.41a.463.463 0 0 1-.13-.32c0-.12.05-.23.13-.32.18-.18.46-.18.64 0L6.1 8.26l3.28-3.28c.17-.17.47-.17.64 0 .17.17.17.46 0 .63z"
    }
  })]);
};
var Success = {
  render
};
var index = function index2() {
  return svg({
    name: "IconSuccess",
    component: Success
  })();
};
export {
  index as default
};
